import customComponentsNO from './configuration/customComponentsNO'
import CustomComponentsSE from './configuration/customComponentsSE'
import Branding from './plugins/Branding'
import MainLogo from './plugins/MainLogo'
import getFormattedSimpleSearchFeatureToggles from './utils/featureTogglesFormatter'
import { isSwedenPortal } from './utils/portalCountry'

const CustomComponents = isSwedenPortal
  ? CustomComponentsSE
  : customComponentsNO

const SearchFieldsNO = [
  'referenceId',
  ...getFormattedSimpleSearchFeatureToggles()
]

const SearchFieldsSE = [
  'referenceId',
  ...getFormattedSimpleSearchFeatureToggles()
]

const SearchFields = isSwedenPortal ? SearchFieldsSE : SearchFieldsNO

export { Branding, MainLogo, CustomComponents, SearchFields }
